import { hashTagsService } from "motw_core/Services/HashTagsService";
import * as React from "react";
import { Dreams } from "source/app/presentation/MainPanel/Dreams/Dreams";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { GetExclusionLinkStyleClass } from "./ExclusionLinks";
import { State } from "source/app/services/UI/State/State";
import { IDreamsState } from "../IDreamsState";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import IDream from "motw_core/Entity/IDream";
import { GetEnergyHashTagsSearchText } from "./GetEnergyHashTagsSearchText";

export function HideEnergyHashtagsLink({ dreams }: { dreams: Dreams }) {
    var energyHashTagsSearchText = GetEnergyHashTagsSearchText();
    const isActive = dreams.state.searchText.includes(energyHashTagsSearchText);

    const count = GetCount(
        dreams.state.dreamsdata,
        dreams.state.selectedDifficulty
    );

    return (
        <IconWithText
            iconSuffix={EGlyphicon["ban-circle"]}
            whenClicked={() => Toggle()}
            displayAsBlock={false}
            withClass={GetExclusionLinkStyleClass(isActive)}
        >
            {`energy #tags (${count})`}
        </IconWithText>
    );
}

function Toggle() {
    const energyHashTagsSearchText = GetEnergyHashTagsSearchText();
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);
    const isActive = dreams.state.searchText.includes(energyHashTagsSearchText);

    const newSearchText = isActive ? "" : energyHashTagsSearchText;

    dreams.setState({
        searchText: newSearchText,
    });
}

export function GetEnergyHashTags(allDreams: IDream[]) {
    const allHashTags = hashTagsService.GetAllDreamHashTags(allDreams);

    const energyHashTags = allHashTags.filter((hashTag) =>
        hashTagsService.IsEnergyHashTag(hashTag)
    );

    return energyHashTags;
}

function GetCount(allDreams: IDream[], selectedDifficulty: number) {
    const energyHashTags = GetEnergyHashTags(allDreams);
    let count = 0;

    const relevantDreams = allDreams.filter(
        (dream) => dream.difficulty <= selectedDifficulty
    );

    relevantDreams.forEach((dream) => {
        const dreamHashTags = hashTagsService.GetAllHashTagsInDream(dream);

        const doesDreamHaveEnergyHashTags =
            energyHashTags.filter((hashTag) => dreamHashTags.includes(hashTag))
                .length > 0;

        if (doesDreamHaveEnergyHashTags) {
            count++;
        }
    });

    return count;
}
